var _path, _path2, _g, _rect, _rect2, _rect3, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgSoonBlueBlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 713,
    height: 400,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E3F2FD",
    d: "m291.67 86.491 23.381-13.498 23.235 13.414-23.381 13.498z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#90CAF9",
    d: "m294.046 87.48 21.023-12.137 20.892 12.061-21.023 12.137z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "m424.188 172.48-12.025-6.942v16.033l.024-.013c.124 1.024.864 2.029 2.221 2.812l114.907 66.337c2.986 1.724 7.829 1.724 10.816 0l106.345-61.394c1.595-.921 2.338-2.148 2.229-3.354v-15.675l-12.186 7.036-104.95-60.588c-2.987-1.724-7.829-1.724-10.816 0z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 135.283,
    height: 145.169,
    fill: "#90CAF9",
    rx: 5,
    transform: "matrix(.86604 -.49997 .86604 .49997 409 165.638)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 135.283,
    height: 145.169,
    fill: "url(#c)",
    rx: 5,
    transform: "matrix(.86604 -.49997 .86604 .49997 409 165.638)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 128.598,
    height: 137.995,
    fill: "url(#d)",
    rx: 5,
    transform: "scale(1.22477 .70707)rotate(-45 452.408 -291.8)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 530.44,
    x2: 412.163,
    y1: 158.777,
    y2: 183.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2196F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1DCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 1.141,
    x2: 46.063,
    y1: 6.084,
    y2: 95.933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91CBFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: -42.084,
    x2: 33.543,
    y1: -101.822,
    y2: 92.059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91CBFA"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: 364.552,
    height: 284.561,
    x: 348.163,
    y: 115.439,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 84
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 32
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.129412 0 0 0 0 0.588235 0 0 0 0 0.952941 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgSoonBlueBlock);
export default __webpack_public_path__ + "static/media/img-soon-blue-block.1dce41dcaf709fcfecd2794d6755bfd5.svg";
export { ForwardRef as ReactComponent };